const translations: { [key: string]: { [key: string]: string } } = {
  accountverification: {
    APP_TITLE: 'Herramienta de Verificación de Documentos Automática',
    IDENTITY_TITLE: 'Verifica tu identidad',
    APP_DESCRIPTION_LINE_1: 'Necesitamos que tu cuenta cumpla con los requisitos',
    APP_DESCRIPTION_LINE_2_BOLD: 'de Edad y de Verificación',
    APP_DESCRIPTION_LINE_2:
      ' exigida por la regulación del juego, por esto, necesitamos que nos remitas la siguiente documentación.',
    DOCUMENT_UPLOAD_MESSAGE: 'Por favor, sube al menos uno de los siguiente documentos:',
    SCENARIO_NUMBER_TITLE: 'Paso',
    CHAT_LINK_TITLE_LINE_1: 'Si necesitas ayuda',
    CHAT_LINK_TITLE_LINE_2: 'Nos puedes contactar a través del chat',
    VERIFICATION_REQUIRED_BTN_VALUE: 'Empezar ahora',
    DOCUMENT_STATUS_VERIFIED: 'VERIFICADO',
    DOCUMENT_STATUS_REJECTED: 'RECHAZADO',
    DOCUMENT_STATUS_PENDING: 'NO SUBIDO',
    DOCUMENT_STATUS_REQUIRED: 'OBLIGATORIO',
    DOCUMENT_STATUS_SUBMITTED: 'ENTREGADO',
    DOCUMENT_STATUS_NOT_UPLOADED: 'NO SUBIDO',
    JOURNEY_COMPLETED_TITLE: '¡Bien hecho!',
    VERIFICATION_COMPLETED: 'Tu proceso de verificación ha sido completado. Tu cuenta ha sido activada.',
    VERIFICATION_COMPLETED_BUTTON_LABEL: 'Por favor, inicia sesión y disfruta.',
    VERIFICATION_COMPLETED_BUTTON_VALUE: 'Inicia sesión',
    SUBMIT_CONFIRMATION:
      'Gracias - Tenemos todo lo que necesitamos por ahora, no nos tomará mucho tiempo revisar la documentación y confirmar si tu cuenta ha sido verificada.',
    SUBMIT_CONFIRMATION_TERM: 'El proceso de confirmación puede demorarse hasta 24h.',
    SUBMIT_CONFIRMATION_FINISHED: 'Te haremos saber si se ha producido algún problema',
    SELECT_DOCUMENT_TYPE_TITLE: 'Selecciona el tipo de documento',
    SELECT_DOCUMENT_BACK_BTN: 'Volver',
    PASSPORT: 'Pasaporte',
    DRIVING_LICENSE: 'Permiso de Conducción',
    IDENTIFY_CARD: 'Carné de Identidad',
    ERROR_TITLE: 'Algo ha ido mal…',
    ERROR_MESSAGE: 'Lo sentimos. Por favor, inténtalo de nuevo.',
    ERROR_BUTTON_VALUE: 'Volver a intentar',
    ERROR_TITLE_TOKEN_EXPIRED: 'El enlace ha expirado',
    ERROR_MESSAGE_TOKEN_EXPIRED:
      'Te hemos enviado un email desde verification@williamhill.com. Por favor, sigue las instrucciones para completar tu verificación',
  },
};

export default translations;
